import type { ReactNode } from 'react';

import { Subtitle, Title } from './typography';

type PageHeaderProps = {
  title: string;
  description?: string;
  action?: ReactNode;
};

/**
 * Page-level header: a `Title` and optional `Subtitle` with consistent spacing (`mb-6`).
 * Compose this at the top of every page. For custom layouts (badges next to title), use `Title`/`Subtitle` directly.
 */
export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div>
        <Title>{title}</Title>
        {description && <Subtitle className="mt-1">{description}</Subtitle>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export type { PageHeaderProps };
